import React from "react";
import "./WorkExp.css"; 

const WorkExp = () => {
  return (
    <div className="stats-container">
      <div className="intro-section">
        <h2>
          For <span className="yearExp">14+ years</span> now we have been responsible for your projects and we are proud of it!
        </h2>
      </div>

      <div className="stats-grid">
        <div className="stat-item">
          <h3 className="stat-number">250+</h3>
          <p className="stat-description">Developed custom solutions</p>
        </div>
        <div className="stat-item">
          <h3 className="stat-number">25+</h3>
          <p className="stat-description">Countries, including the USA</p>
        </div>
        <div className="stat-item">
          <h3 className="stat-number">3+</h3>
          <p className="stat-description">Years' Client engagement</p>
        </div>

        <div className="stat-item">
          <h3 className="stat-number">98%</h3>
          <p className="stat-description">Satisfaction rate</p>
        </div>
      </div>
    </div>

  );
};

export default WorkExp;
